export class PagedResultDtoOfGetDeviceForView {
  totalCount!: number | undefined;
  items!: GetDeviceForView[] | undefined;
}

export class GetDeviceForView {
  device!: DeviceDto | undefined;
}

export interface IDeviceDtoModelData {
  result: DeviceDto[];
}

export class DeviceDto implements IDeviceDto {
  parentId!: number | undefined;
  siteId!: number | undefined;
  deviceTypeId!: number | undefined;
  name!: string | undefined;
  description!: string | undefined;
  vendorId!: string | undefined;
  isActive!: boolean | undefined;
  createdBy!: number | undefined;
  createdDate!: Date | undefined;
  updatedBy!: number | undefined;
  updatedDate!: Date | undefined;
  statusId!: number | undefined;
  sourceId!: number | undefined;
  assetTag!: string | undefined;
  id!: number | undefined;
}

export interface IDeviceDto {
  parentId: number | undefined;
  siteId: number | undefined;
  deviceTypeId: number | undefined;
  name: string | undefined;
  description: string | undefined;
  vendorId: string | undefined;
  isActive: boolean | undefined;
  createdBy: number | undefined;
  createdDate: Date | undefined;
  updatedBy: number | undefined;
  updatedDate: Date | undefined;
  statusId: number | undefined;
  sourceId: number | undefined;
  assetTag: string | undefined;
  id: number | undefined;
}

export class DeviceStatistics {
  numOfCameras: number;
  numOfCamerasDown: string;
  daysOfHistoryExpected: number;
  medianAverage: string;
}

export class DeviceTemplate {
  deviceId!: number | undefined;
  deviceTypeId!: number | undefined;
  parentId!: number | undefined;
  createdBy!: number | undefined;
  createdDate!: moment.Moment | undefined;
  updatedBy!: number | undefined;
  updatedDate!: moment.Moment | undefined;
}

//#region DEVICE ALARMS
export class DeviceAlarmDetail {
  id?: number;
  parentId:number;
  siteId: number;
  deviceTypeId:number;
  name: string;
  description: string;
  vendorId: string;
  statusId: number;
  sourceId: number;
  createdDate: Date;
  updatedDate?: Date;
}

export class CreateUpdateDeviceAlarmDetail {
  id?: number;
  parentId:number;
  siteId: number;
  deviceTypeId:number;
  name: string;
  description: string;
  vendorId: string;
  statusId: number;
  sourceId: number;
}

//#endregion DEVICE ALARMS

//#region DEVICE CREDENTIALS
export class DeviceCredentialDto {
  deviceId!: number | undefined;
  credentialId!: number | undefined;
  login!: string | undefined;
  password!: string | undefined;
  loginTypeId!: number | undefined;
  createdBy!: number | undefined;
  createdDate!: Date | undefined;
  updatedBy!: number | undefined;
  updatedDate!: Date | undefined;
}
//#endregion DEVICE CREDENTIALS

//#region NVR PORTS
export class NVRPortDto {
  id!: number | undefined;
  nvrId!: number | undefined;
  portTypeId!: number | undefined;
  portNumber!: number | undefined;
  portTypeLookupId!: number | undefined;
  createdBy!: number | undefined;
  createdDate!: Date | undefined;
  updatedBy!: number | undefined;
  updatedDate!: Date | undefined;
}
//#endregion


//#region DEVICE NOTES
export class DeviceNoteDto {
  deviceId!: number | undefined;
  noteId!: number | undefined;
  noteGroupTypeId!: number | undefined;
  noteTypeId!: number | undefined;
  body!: string | undefined;
  createdBy!: number | undefined;
  createdDate!: Date | undefined;
  updatedBy!: number | undefined;
  updatedDate!: Date | undefined;
}
//#endregion DEVICE NOTES

//#region DEVICE NVR
export class CreateOrEditNVRDto  {
  device!: DeviceDto;
  nvr!: NVRGeneralDto;
  deviceCredentials!: DeviceCredentialDto[];
  ports!: NVRPortDto[];
  physicalAccess!: NVRPhysicalAccessDto | undefined | null;
  deviceNotes!: DeviceNoteDto[];
  createdByName!: string;
  updatedByName!: string;
  smtpConfiguration: SmtpConfigurationDto | null;
}

export class NVRGeneralDto {
  lineupThresholdMinutes!: number | undefined;
  isRental!: boolean | undefined;
  isServiced!: boolean | undefined;
  isGuardTour!: boolean | undefined;
  isLiveMonitored!: boolean | undefined;
  isLoaner!: boolean | undefined;
  isRequiredQuote!: boolean | undefined;
  activatedDate!: Date | undefined;
  deactivatedDate!: Date | undefined;
  warrantyServiceEndDate!: Date | undefined;
  installationDate!: Date | undefined;
  backupDate!: Date | undefined;
  osTypeId!: number | undefined;
  osVersion!: string | undefined;
  nvrTypeId!: number | undefined;
  nvrVersionId!: number | undefined;
  countryId!: number | undefined;
  timeZoneId!: number | undefined;
  isDSTIgnored!: boolean | undefined;
  winProductKey!: string | undefined;
  customerPriorityId!: number | undefined;
  monitoringPlatformTypeId!: number | undefined;
  monitoringPlatformVersion!: string | undefined;
  canUseRTSP!: boolean | undefined;
  canUseRTSPConnect!: boolean | undefined;
  createdBy!: number | undefined;
  createdDate!: Date | undefined;
  updatedBy!: number | undefined;
  updatedDate!: Date | undefined;
  deviceId!: number | undefined;
  verticalTypeId!: number | undefined;
  vmsType!: string | undefined;
  rtspPort!: number | undefined;
  remoteServerTypeId!: number | undefined;
  useSEAI!: boolean | undefined;

  scConnectionTypeId!: number | undefined;
  svConnectionTypeId!: number | undefined;

  useMediaMTX!: boolean | undefined;
}

export class NVRPhysicalAccessDto {
  deviceId!: number | undefined;
  physicalAccessId!: number | undefined;
  description!: string | undefined;
  notes!: string | undefined;
  keyStorageLocation!: string | undefined;
  accessCode!: string | undefined;
  isDeleted!: boolean | undefined;
  isPhysicalKey!: boolean | undefined;
  createdBy!: number | undefined;
  createdDate!: Date | undefined;
  updatedBy!: number | undefined;
  updatedDate!: Date | undefined;
}

export class NVRDetailDatesDto {
  deviceId: number;
  deviceName: string;
  warrantyServiceEndDate: string;
  activatedDate: string;
  deactivatedDate: string;
  updatedBy: string | undefined;
  updatedDate: Date | undefined;

  get activatedDateObject(): Date | undefined {
    if (this.activatedDate !== undefined && this.activatedDate !== null
      && this.activatedDate.trim() !== '' && !this.activatedDate.startsWith('0001')) {
      return new Date(this.activatedDate);
    }

    return undefined;
  }

  get deactivatedDateObject(): Date | undefined {
    if (this.deactivatedDate !== undefined && this.deactivatedDate !== null
      && this.deactivatedDate.trim() !== '' && !this.deactivatedDate.startsWith('0001')) {
      return new Date(this.deactivatedDate);
    }

    return undefined;
  }

  get warrantyServiceEndDateObject(): Date | undefined {
    if (this.warrantyServiceEndDate !== undefined && this.warrantyServiceEndDate !== null && this.warrantyServiceEndDate.trim() !== '')
      return new Date(this.warrantyServiceEndDate);

    return undefined;
  }
}

export class NVRDetailServiceDto extends NVRDetailDatesDto {
  monitoringPlatformTypeName: string;
}

export class NVRDetailDatesParameter {
  NVRs: Array<NVRDetailDatesDto>;
}

export class NVRNameDto {
  id: number;
  name: string;
}

//#endregion DEVICE NVR

//#region DEVICE TAGS
export class DeviceTagParameter {
  deviceId: number;
  tagIds: Array<number>
}
//#endregion DEVICE TAGS

export class SmtpConfigurationDto {
  deviceId?: number;
  serverTypeId: number;
  port: number;
  sNumber?: string;
  toEmailAddress?: string;
  fromEmailAddress?: string;
  subject: string;
  message?: string;
  numberOfImages: number;
  delayBetweenImages: number;
  imageHeight: number;
  imageWidth: number;
  isSecure: boolean;
  isMaskRequired: boolean;
  isActive: boolean;
}
